import { NavLink } from 'react-router-dom';
import type { ComponentType, SVGProps } from 'react';
import {
  IconHistory,
  IconHome,
  IconStethoscope,
  IconUser,
  IconUserPlus,
} from '@/components/Icon';

type Item = {
  to: string;
  label: string;
  Icon: ComponentType<SVGProps<SVGSVGElement> & { size?: number }>;
};

const items: Item[] = [
  { to: '/', label: 'Accueil', Icon: IconHome },
  { to: '/new-patient', label: 'Patient', Icon: IconUserPlus },
  { to: '/shift', label: 'Quart', Icon: IconStethoscope },
  { to: '/history', label: 'Historique', Icon: IconHistory },
  { to: '/profile', label: 'Profil', Icon: IconUser },
];

export function BottomNav() {
  return (
    <nav className="fixed bottom-0 inset-x-0 bg-brand-darkest/95 backdrop-blur border-t border-white/10 pb-[env(safe-area-inset-bottom)]">
      <ul className="flex items-stretch justify-around">
        {items.map(({ to, label, Icon }) => (
          <li key={to} className="flex-1">
            <NavLink
              to={to}
              end={to === '/'}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-0.5 py-2 text-[10px] font-medium ${
                  isActive ? 'text-brand-orange' : 'text-white/55'
                }`
              }
            >
              <Icon size={22} />
              <span>{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
